<template>
  <div class="audio-container">

    <div v-if="errorMessage" class="error-box">
      {{ errorMessage }}
    </div>

    <div class="controls" v-if="canRecord">
      <button
          @click="startRecording"
          :disabled="isRecording || !canRecord"
      >
        شروع ضبط 🎤
      </button>

      <button
          @click="stopRecording"
          :disabled="!isRecording"
      >
        پایان ضبط ⛔
      </button>
    </div>

    <div v-if="audioUrl" class="preview">
      <audio :src="audioUrl" controls></audio>
      <button @click="emitRecordedFile">ذخیره صدا ✔️</button>
    </div>

    <hr/>

    <div>
      <label for="upload" class="ml-1 btn btn-primary"> <i class="fa fa-cloud-upload ml-2"></i>آپلود فایل صوتی</label>
      <input type="file" id="upload" class="d-none" ref="audioInput" accept="audio/*" @change="fileSelected"/>
    </div>

    <div class="w-100 mt-2" v-if="uploadedFileName">
      <p>
        فایل انتخاب شده: **{{ uploadedFileName }}**
        <button @click="clearSelectedFile" class="btn btn-sm btn-danger ml-2"
                style="font-size: 1.2rem; line-height: 1; padding: 0.1rem 0.5rem;">
          &times;
        </button>
      </p>

    </div>
    <div class="w-100 pt-3 text-center">
      <button class="btn btn-success" @click="emitUploadedFile">ذخیره فایل</button>
    </div>

  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue';

const isRecording = ref(false);
let mediaRecorder;
const audioChunks = [];
const audioUrl = ref(null);
let recordedBlob = null;
const props = defineProps({
  file: {
    required: false
  },
})
const errorMessage = ref("");  // پیام خطا
const canRecord = ref(false);  // قابلیت ضبط
const audioInput = ref(null);

// بررسی اینکه آیا میکروفن قابل دسترسی است
onMounted(async () => {
  try {
    await navigator.mediaDevices.getUserMedia({audio: true}); // تست گرفتن دسترسی
    canRecord.value = true;
  } catch (err) {
    canRecord.value = false;
    errorMessage.value = "⚠️ دستگاه شما قابلیت ضبط صدا ندارد یا دسترسی میکروفن مسدود است.";
  }
  if(props.file){
    uploadedFileName.value = props.file.name
  }
});

const startRecording = async () => {
  try {
    isRecording.value = true;
    audioChunks.length = 0;

    const stream = await navigator.mediaDevices.getUserMedia({audio: true});
    mediaRecorder = new MediaRecorder(stream);

    mediaRecorder.ondataavailable = (e) => audioChunks.push(e.data);

    mediaRecorder.onstop = () => {
      recordedBlob = new Blob(audioChunks, {type: 'audio/webm'});
      audioUrl.value = URL.createObjectURL(recordedBlob);
    };

    mediaRecorder.start();
  } catch (err) {
    errorMessage.value = "❌ هنگام شروع ضبط خطایی رخ داد. لطفا دوباره تلاش کنید.";
  }
};

const stopRecording = () => {
  if (mediaRecorder) {
    isRecording.value = false;
    mediaRecorder.stop();
  }
};

const emitRecordedFile = () => {
  const file = new File([recordedBlob], "recorded-audio.webm", {type: "audio/webm"});
  emit("audioSelected", file);
};

const uploadedFileName = ref(null);
let uploadedFile = null;
const clearSelectedFile = () => {
  uploadedFile = null
  uploadedFileName.value = ''
  audioInput.value.value = "";
}
const fileSelected = (e) => {
  uploadedFile = e.target.files[0];
  uploadedFileName.value = uploadedFile?.name;
};

const emitUploadedFile = () => {
  emit("audioSelected", uploadedFile);
};

const emit = defineEmits(["audioSelected"]);
</script>

<style scoped>
.audio-container {
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 100%;
  direction: rtl;
}

.controls button {
  margin: 5px;
}

.preview {
  margin-top: 15px;
}

.error-box {
  background: #ffdddd;
  color: #b80000;
  border: 1px solid red;
  padding: 8px;
  border-radius: 6px;
  margin-bottom: 10px;
}
</style>
